import {Fragment} from "react";
import {styled} from "@mui/material";
import UploadImageComponent from "../../../Input/UploadImageComponent";
import FactorSettingPatternList from "./FactorSettingPatternList";
import {StyledAvatar} from "components/Shared/Dashboard/styled";
import uploadLogo from "assets/images/uploadLogo.svg";

const ButtonContainer = styled("div")(({theme}) => ({
    height: "250px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
const ListContainer = styled("div")(({theme}) => ({
    padding: "16px",
}));

const AvatarContainer = styled("div")(({theme}) => ({
    width: "45px",
    height: "45px",
}));

const LogoPLaceholder = () => {
    return (
        <AvatarContainer>
            <StyledAvatar sx={{borderRadius: 0}} src={uploadLogo}/>
        </AvatarContainer>
    );
};

const FactorBaseSetting = () => {
    return (
        <Fragment>
            <ButtonContainer>
                <UploadImageComponent
                    title="آپلود لوگو"
                    name="logo"
                    width={150}
                    height={150}
                    innerWidth={130}
                    innerHeight={130}
                    LogoPlaceholder={LogoPLaceholder}
                />
            </ButtonContainer>
            <ListContainer>
                <FactorSettingPatternList/>
            </ListContainer>
        </Fragment>
    );
};

export default FactorBaseSetting;
